// pages/LabPage.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Card } from 'react-bootstrap';
import PieChartComponent from '../components/PieChartComponent';
import { fetchSpacesData, fetchVisitData, fetchWalkInVisitLogs, fetchClassVisitLogs } from '../services/SpacesApi';
import ErrorMessage from '../components/ErrorMessage';
import { formatPieChartData } from '../services/dataFormatter';
import VisitTable from '../components/VisitTable';
import CountUp from "react-countup";


const LabPage = ({ startDate, endDate, loading, error, setError, setLoading }) => {
  const [spacesResponse, setSpacesResponse] = useState(null);
  const [visitResponse, setVisitResponse] = useState(null);
  const [walkInVisitLogs, setWalkInVisitLogs] = useState([]);
  const [classVisitLogs, setClassVisitLogs] = useState([]);


  const loadData = async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    setError(null);
    try {
      const [spacesData, visitData, walkInLogs, classLogs] = await Promise.all([
        fetchSpacesData(startDate, endDate),
        fetchVisitData(startDate, endDate),
        fetchWalkInVisitLogs(startDate, endDate),
        fetchClassVisitLogs(startDate, endDate),
      ]);

      setSpacesResponse(spacesData);
      setVisitResponse(visitData);
      setWalkInVisitLogs(walkInLogs);
      setClassVisitLogs(classLogs);
    } catch (err) {
      setError('Error loading data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const totalVisitors =
    Number(visitResponse?.class || 0) +
    Number(visitResponse?.["walk-in"] || 0) +
    Number(spacesResponse?.digitalLabBooking || 0);

  return (
    <div>
      <Container className="mt-5">
        {visitResponse && (
          <Row>
            <Col md={6} xs={12} className="mx-auto">
              <Card className="collection-box h-100 text-center">
                <Card.Body>
                  <Card.Title className="collection-title">Total bookings</Card.Title>
                  <Card.Text className="collection-value">
                    <CountUp end={totalVisitors} duration={2} separator="," />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col md={6} xs={12} className="mx-auto">
              <Card className="collection-box h-100 text-center">
                <Card.Body>
                  <Card.Title className="collection-title">Walk-in visit</Card.Title>
                  <Card.Text className="collection-value">{visitResponse["walk-in"] ?? 0}</Card.Text>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>
        )}

        {loading && (
          <Row className="justify-content-center">
            <Col xs="auto">
              <Spinner animation="border" role="status" />
              <span className="ms-2">Loading...</span>
            </Col>
          </Row>
        )}

        {error && (
          <Row className="justify-content-center">
            <Col xs="auto">
              <ErrorMessage message={error} />
            </Col>
          </Row>
        )}

        {spacesResponse && (
          <Row className="mb-3">
            <Col md={6} xs={12} className="mx-auto">
              <PieChartComponent data={formatPieChartData(spacesResponse.hoursPerWeekdayDigitalArts, "Reservations Hours Per WeekDay")} />
            </Col>
          </Row>
        )}

        <Row>
          {walkInVisitLogs && walkInVisitLogs.length > 0 && (
            <Col md={6}>
              <VisitTable title="Walk-In Visit Logs" data={walkInVisitLogs} />
            </Col>
          )}
          
          {classVisitLogs && classVisitLogs.length > 0 && (
            <Col md={6}>
              <VisitTable title="Class Visit Logs" data={classVisitLogs} />
            </Col>
          )}
        </Row>

      </Container>
    </div>
  );
};

export default LabPage;
